import './plugins.composition-api'
import './plugins.lib'
import './plugins.components'
import './plugins.styles'
import './plugins.echarts'
// import './plugins.amap'
import './plugins.error'
import './plugins.has-permi'
import './plugins.mixins'
import './plugins.permission'
import './plugins.intercept'
import './plugins.no-space'
import './plugins.no-emoji'
